module.exports = __webpack_public_path__ + "static/media/3g-network-repeated-visit.481cc67f.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/step-3/3g-network-repeated-visit.png
 ** module id = 352
 ** module chunks = 0
 **/